import { ArrowRight, Smartphone } from "lucide-react";
import appStoreBadge from "../assets/platform/download-on-app-store.svg";

const HEPAPAL_APP_STORE_URL = "https://apps.apple.com/app/hepapal/id6799496089";

type AppStoreCtaProps = {
  className?: string;
  label?: string;
  variant?: "button" | "badge";
};

export function AppStoreCta({
  className = "",
  label = "Download on the App Store",
  variant = "button",
}: AppStoreCtaProps) {
  const classes = `${className} app-store-cta`.trim();

  if (variant === "badge") {
    return (
      <a
        className={`${classes} app-store-badge-link`}
        href={HEPAPAL_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download HepaPal on the App Store"
      >
        <img className="app-store-badge" src={appStoreBadge} alt="Download on the App Store" />
      </a>
    );
  }

  return (
    <a
      className={classes}
      href={HEPAPAL_APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download HepaPal on the App Store"
    >
      <Smartphone aria-hidden="true" />
      <span className="button-label">{label}</span>
      <ArrowRight aria-hidden="true" />
    </a>
  );
}
